var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Viewport',[_c('main',{staticClass:"r-cover overflow-hidden"},[_c('vue-announcer'),_c('RouterView',{ref:"routerView"}),_c('vue-progress-bar'),(!_vm.loading)?_c('Cookies'):_vm._e(),_c('Transition',{attrs:{"name":"fade"}},[(_vm.loading)?_c('Loading'):_vm._e()],1),_c('IePrompt',{staticClass:"z-400"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }